import React from 'react';
import { Image as AntImage, ImageProps as AntImageProps } from 'antd';

export type ImageProps = AntImageProps;

export const Image: React.FC<ImageProps> = (props) => (
  <AntImage preview={false} className="max-w-40 !h-auto" {...props} />
);
